import { ConfirmationModal } from "components/ActionModals/ConfirmationModal";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";

import { returnContractToDraftForCustomer } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { requestWithNotify } from "utils";

export const DeclineToDraftBtn = observer(() => {
  const { contractCard, actionModals } = useStores();
  const { openNotification } = useNotificationContext();

  const openDeclineDraftModal = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          calledQuery={async () => {
            await returnContractToDraftForCustomer({ id: contractCard.card.id });
          }}
          successText="Черновик договора успешно вернут на рассмотрение"
          text={"Вы уверены, что хотите вернуть договор на рассмотрение?"}
          textAlign="start"
          onSuccess={async () => {
            actionModals.closeAll();
            await requestWithNotify({
              fetchFn: () => contractCard.fetchCardById(contractCard.card.id),
              openNotification,
              showErrorNotification: false,
              delay: 1000,
            });
            await requestWithNotify({
              fetchFn: () => contractCard.history.fetchHistory(contractCard.card.id),
              openNotification,
              showErrorNotification: false,
              delay: 500,
            });
          }}
          fullWidth={true}
          buttonText="Подтвердить"
        />
      ),
      {
        width: "600px",
        noValidation: true,
        isOverlayClose: false,
        title: "Вернуть на рассмотрение",
        onApply: () => Promise.resolve(),
      }
    );
  };

  return (
    <CustomButton type="default" onClick={openDeclineDraftModal} tooltip="Вернуть договор на рассмотрение">
      Вернуть на рассмотрение
    </CustomButton>
  );
});
